/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import api from 'api';
import { Header, SideMenu, Search, Button, Dialog, Input, Select, DataTable } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ModalButton } from './styles';
import { loadingColor, primary, white } from 'styles/colorProvider';
import { TiFilter } from 'react-icons/ti';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { toast } from 'react-toastify';
import ExportToExcel from 'components/ExportToExcel/index';
import { partnersInfo } from 'utils/general';
import { Alert } from '@material-ui/lab';
import { dataColumns } from './helper';

const dateFilters = {
  created_at: 'Data de criação',
  due_at: 'Data de vencimento',
  paid_at: 'Data de pagamento',
};

function Charges({ history }) {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [chargesList, setChargesList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);

  const [search, setSearch] = useState('');
  const [openFilter, setOpenFilter] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [exportData, setExportData] = useState();
  const [touchFilter, setTouchFilter] = useState(false);

  const [startData, setStartData] = useState('');
  const [endData, setEndData] = useState('');
  const [selectStatus, setSelectStatus] = useState('all');
  const [selectedPartner, setSelectedPartner] = useState('all');
  const [dateFilter, setDateFilter] = useState('');
  const [dateFilterStartDate, setDateFilterStartDate] = useState('');
  const [dateFilterEndDate, setDateFilterEndDate] = useState('');
  const [exportErrorMessage, setExportErrorMessage] = useState('');

  const loadData = async () => {
    setLoading(true);
    try {
      setCurrentPage(1);
      const resp = await api({
        method: 'GET',
        url: `/charges-list-reports`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        params: {
          search,
          startdate: startData === '' ? undefined : startData,
          enddate: endData === '' ? undefined : endData,
          status: selectStatus === 'all' ? undefined : selectStatus,
          partner: selectedPartner === 'all' ? undefined : selectedPartner,
          page: 1,
          take: 20,
        },
        json: true,
      });
      setChargesList(resp?.data?.charges || []);
      setTotalCount(resp?.data?.totalCount || 0);
      setHasNextPage(resp?.data?.hasNextPage || false);
      setTouchFilter(false);
    } catch (error) {
      toast.error('Erro ao carregar cobranças');
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = async () => {
    if (!touchFilter && hasNextPage && !loadingMore) {
      setLoadingMore(true);
      const nextPage = currentPage + 1;
      try {
        const resp = await api({
          method: 'GET',
          url: `/charges-list-reports`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitrisk-authtoken'),
          },
          params: {
            search,
            startdate: startData === '' ? undefined : startData,
            enddate: endData === '' ? undefined : endData,
            status: selectStatus === 'all' ? undefined : selectStatus,
            partner: selectedPartner === 'all' ? undefined : selectedPartner,
            page: nextPage,
            take: 20,
          },
          json: true,
        });
        setChargesList([...chargesList, ...(resp?.data?.charges || [])]);
        setCurrentPage(nextPage);
        setHasNextPage(resp?.data?.hasNextPage || false);
      } catch (error) {
        toast.error('Erro ao carregar mais cobranças');
      } finally {
        setLoadingMore(false);
      }
    }
  };

  const handleClear = () => {
    setSelectStatus('all');
    setStartData('');
    setEndData('');
    setSelectedPartner('all');
  };

  const handleExport = async () => {
    setLoadingExport(true);
    setExportErrorMessage('');

    if (!dateFilter) {
      setExportErrorMessage('Selecione um filtro de data');
      setLoadingExport(false);
      return;
    }
    if (!dateFilterStartDate || !dateFilterEndDate) {
      setExportErrorMessage('Informe as datas de início e fim');
      setLoadingExport(false);
      return;
    }

    const datePattern = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!datePattern.test(dateFilterStartDate) || !datePattern.test(dateFilterEndDate)) {
      setExportErrorMessage('Formato de data inválido');
      setLoadingExport(false);
      return;
    }

    try {
      const resp = await api({
        method: 'POST',
        url: `/export-charges`,
        params: {
          fromPortal: true,
          dateFilterColumn: dateFilter,
          startDate: dateFilterStartDate,
          endDate: dateFilterEndDate,
          partner: selectedPartner === 'all' ? undefined : selectedPartner,
        },
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
          feature: 'export-charges',
        },
        json: true,
      });
      setExportData(resp.data);
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Não foi possível exportar cobranças', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      setOpenExport(false);
    } finally {
      setLoadingExport(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const renderExportDialog = () => (
    <Dialog
      open={openExport}
      onClose={() => {
        !loadingExport && setOpenExport(false);
        setExportData();
        setExportErrorMessage('');
      }}
      width="50%"
      title="Exportar cobranças"
    >
      {!exportData && (
        <>
          <Select label="Parceiro" height="35px" value={selectedPartner} onChange={(e) => setSelectedPartner(e.target.value)}>
            <option value="all">Todos os parceiros</option>
            {partnersInfo?.map((p) => (
              <option key={p.id_partner} value={p.id_partner}>
                {p.name}
              </option>
            ))}
          </Select>

          <Select label="Filtro por data" height="35px" value={dateFilter} onChange={(e) => setDateFilter(e.target.value)}>
            <option value="">Nenhum</option>
            {Object.keys(dateFilters).map((key) => (
              <option key={key} value={key}>
                {dateFilters[key]}
              </option>
            ))}
          </Select>

          {dateFilter && (
            <>
              <Input
                label={`${dateFilters[dateFilter]} inicial`}
                value={dateFilterStartDate}
                onChange={(e) => setDateFilterStartDate(e.target.value)}
                mask="99/99/9999"
                height="30px"
              />
              <Input
                label={`${dateFilters[dateFilter]} final`}
                value={dateFilterEndDate}
                onChange={(e) => setDateFilterEndDate(e.target.value)}
                mask="99/99/9999"
                height="30px"
              />
            </>
          )}

          {exportErrorMessage && (
            <Alert severity="error" style={{ marginTop: '10px' }}>
              {exportErrorMessage}
            </Alert>
          )}

          <ModalButton>
            <Button height="35px" onClick={handleExport} disabled={loadingExport}>
              {loadingExport ? <ReactLoading color={white} height={25} width={25} type="spin" /> : 'Exportar'}
            </Button>
          </ModalButton>
        </>
      )}

      {exportData?.length > 0 && (
        <>
          <p style={{ textAlign: 'center', marginBottom: '10px' }}>Seu arquivo está pronto!</p>
          <ExportToExcel exportData={exportData} fileName={`cobrancas_${new Date().toLocaleDateString()}`} />
        </>
      )}
    </Dialog>
  );

  return (
    <>
      <Header />
      <Container>
        {renderExportDialog()}
        <SideMenu />
        <ContentArea>
          <Div>
            <Title>COBRANÇAS</Title>
            <div className="containerTitle">
              <Button height="30px" onClick={() => setOpenExport(true)}>
                <RiFileExcel2Fill size={18} />
              </Button>
              <Button height="30px" onClick={() => setOpenFilter(true)}>
                <TiFilter size={18} />
              </Button>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData();
                }}
                onConfirm={() => loadData()}
              />
            </div>
          </Div>
          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <DataTable
                columns={dataColumns}
                data={chargesList}
                persistTableHead
                responsive
                highlightOnHover
                fixedHeader
                fixedHeaderScrollHeight="100%"
                progressPending={loading}
                progressComponent={
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                }
                noDataComponent={<small style={{ marginTop: 20 }}>Nenhuma cobrança encontrada</small>}
              />
            </InfiniteScroll>
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}
            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {chargesList.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default Charges;
